export const ROUTING = '[ROUTING]'
export const GOTO_HOME = `${ROUTING} Go to Home page`
export const GOTO_SETTINGS = `${ROUTING} Go to Settings page`
export const GOTO_ADVENTURE = `${ROUTING} Go to Adventure page`
export const GOTO_SQUAD = `${ROUTING} Go to Squad page`
export const GOTO_UNIT = `${ROUTING} Go to Unit page`
export const GOTO_BATTLE = `${ROUTING} Go to Battle page`
export const GOTO_BATTLE_RESULT = `${ROUTING} Go to Battle Result page`

export const goToHome = () => ({
    type: GOTO_HOME,
    meta: {
        gameState: 'routing',
    },
})
export const goToSettings = () => ({
    type: GOTO_SETTINGS,
    meta: {
        gameState: 'routing',
    },
})
export const goToAdventure = () => ({
    type: GOTO_ADVENTURE,
    meta: {
        gameState: 'routing',
    },
})
export const goToSquad = () => ({
    type: GOTO_SQUAD,
    meta: {
        gameState: 'routing',
    },
})
export const goToUnit = target => ({
    type: GOTO_UNIT,
    payload: {
        unitID: target,
    },
    meta: {
        gameState: 'routing',
    },
})
export const goToBattle = stage => ({
    type: GOTO_BATTLE,
    payload: {
        battleStage: stage,
    },
    meta: {
        gameState: 'routing',
    },
})
export const goToBattleResult = () => ({
    type: GOTO_BATTLE_RESULT,
    meta: {
        gameState: 'routing',
    },
})
